import { HelpBubbleWidget } from './HelpBubbleWidget';
import { RoleSelectionModal } from './components/RoleSelectionModal';
import { AttendeeTicketsModal } from './components/AttendeeTicketsModal';

export const HelpBubble = () => {
  return (
    <>
      <HelpBubbleWidget />
      <RoleSelectionModal />
      <AttendeeTicketsModal />
    </>
  );
};

export default HelpBubble;
